import {lazy} from 'react';

export const FxRatesChartLazy = lazy(() => import(/* webpackChunkName: "fxRatesChart" */ '.'));
